var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFk = function SvgIconFk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.968 12H12v-.032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.26V0h-.002C5.372 0 0 5.373 0 12h6.26V8.474L9.787 12h2.182l.032-.032V9.786L8.474 6.261z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.07 1.565A12.06 12.06 0 0 0 1.564 6.07V12h3.13V4.695H12v-3.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999 10.524 7.735 6.261H6.26l5.739 5.74z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M19.305 14.086v.522H15.13v-.522h-1.566v2.087h1.044v.522h5.217v-.522h1.044v-2.087z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M13.565 6.261v5.74c0 2.795 3.653 3.652 3.653 3.652S20.87 14.796 20.87 12V6.26z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F3F3F3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.217 10.543c-.913 0-.913.835-1.826.835s-.913-.835-1.826-.835v1.46c.913 0 .913.836 1.826.836s.913-.835 1.826-.835.913.835 1.827.835.913-.835 1.826-.835v-1.461c-.913 0-.913.835-1.826.835-.914 0-.914-.835-1.827-.835M17.217 7.618c-.913 0-.913.835-1.826.835s-.913-.835-1.826-.835V9.08c.913 0 .913.835 1.826.835s.913-.835 1.826-.835.913.835 1.827.835.913-.835 1.826-.835v-1.46c-.913 0-.913.834-1.826.834-.914 0-.914-.835-1.827-.835"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconFk;